<template>
  <List v-if="viewType === 'list'" />
  <Detail v-else-if="viewType === 'detail'" />
</template>

<script setup>
import { watch, ref } from "vue";
import { useRoute } from "vue-router";
import List from "./Test/List.vue";
import Detail from "@/Components/AppDetail/index.vue";

const route = useRoute();

const viewType = ref("");
watch(
  () => route.query?.action,
  /**
   * @param {string?} action
   */
  (action) => {
    if (action === undefined) {
      viewType.value = "list";
    } else {
      viewType.value = action;
    }
  },
  { immediate: true }
);
</script>
